import React from "react";
import MainLayout from "../layout/MainLayout";
import { Disclosure } from "@headlessui/react";
import { ChevronDown } from "lucide-react";
import { motion } from "framer-motion";

const faqs = [
  {
    question: "Do I need a visa to visit Uganda?",
    answer:
      "Yes, most travelers need a visa to enter Uganda. You can apply online through the Uganda eVisa portal. It’s a quick and easy process.",
  },
  {
    question: "What’s the best time to visit Uganda?",
    answer:
      "Uganda is a year-round destination, but the dry seasons (Dec–Feb & Jun–Aug) are ideal for wildlife viewing and trekking.",
  },
  {
    question: "Are Muhaad tours customizable?",
    answer:
      "Absolutely! All our tours are 100% customizable based on your preferences, budget, and schedule.",
  },
  {
    question: "Is it safe to travel in Uganda?",
    answer:
      "Yes, Uganda is generally safe for tourists. Muhaad ensures all travel routes, lodges, and activities follow strict safety protocols.",
  },
  {
    question: "Do you offer airport pickup and drop-off?",
    answer:
      "Yes! All our packages include airport pickup and drop-off in comfortable, private vehicles.",
  },
  {
    question: "What should I pack for a gorilla trek?",
    answer:
      "We recommend long pants, waterproof boots, gloves, a rain jacket, and a good camera. We’ll send you a full checklist after booking.",
  },
];

export const FAQ = () => {
  return (
    <MainLayout>
      {/* Header */}
      <section className="text-center max-w-4xl mx-auto px-6 mt-12 mb-16">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-4xl font-bold mb-4"
        >
          Frequently Asked Questions
        </motion.h1>
        <p className="text-lg text-gray-600 dark:text-gray-300">
          Everything you need to know before booking with Muhaad.
        </p>
      </section>

      {/* FAQ Grid */}
      <section className="max-w-5xl mx-auto px-4 mb-24 space-y-6">
        {faqs.map((item, index) => (
          <Disclosure key={index}>
            {({ open }) => (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                className="border border-white/20 dark:border-white/10 bg-white/30 dark:bg-white/10 backdrop-blur-md rounded-xl p-4"
              >
                <Disclosure.Button className="w-full flex justify-between items-center text-left text-lg font-medium text-gray-800 dark:text-white">
                  <span>{item.question}</span>
                  <ChevronDown
                    className={`w-5 h-5 transition-transform duration-300 ${
                      open ? "rotate-180" : ""
                    }`}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="mt-2 text-sm text-gray-700 dark:text-gray-300">
                  {item.answer}
                </Disclosure.Panel>
              </motion.div>
            )}
          </Disclosure>
        ))}
      </section>
    </MainLayout>
  );
};
